<template>
  <el-button
    size="small"
    type="success"
    @click="exportExcel"
    class="export-btn"
  >导出</el-button>
</template>

<script>
import { Loading } from "element-ui";
import axios from "axios";
import qs from 'qs';
export default {
  name: "ExportExcelBtn",
  props: {
    apiUrl: String,
    queryParamsObj: Object,
    fileName: {
      type: String,
      default: "报表数据",
    },
  },
  methods: {
    exportExcel () {
      const loading = Loading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let queryParams = JSON.parse(JSON.stringify(this.queryParamsObj)); //不能修改props中对象信息，要用深拷贝
      queryParams.pageIndex = 1;
      queryParams.pageSize = 100000;
      axios({
        method: "GET",
        url: `${this.apiUrl}?${qs.stringify(queryParams)}`,
        //params: queryParams,
        responseType: "blob",
      })
        .then((data) => {
          if (data.data) {
            setTimeout(() => {
              loading.close();
            }, 1000);
            let a = document.createElement("a");
            if ("download" in a) {
              // 判断浏览器是否支持HTML5 download属性
              let blob = new Blob([data.data]); // 将Excel文件流转换为Blob对象
              let url = window.URL.createObjectURL(blob); // 创建一个指向该Blob对象的URL
              a.href = url;
              a.download = this.fileName; // 设置下载文件的文件名和扩展名
              a.click(); // 模拟点击链接实现下载
              window.URL.revokeObjectURL(url); // 释放URL资源
            } else {
              navigator.msSaveBlob(new Blob([data.data]), this.fileName); // 兼容IE浏览器
            }
          }
        })
        .catch((err) => {
          loading.close();
          console.log(err);
          this.$Alert.info({
            content: `导出失败，接口请求异常`,
            duration: 3000,
            status: "error",
          });
        });
    },
  },
};
</script>

<style scoped>
.export-btn {
  width: 72px;
}
</style>
